import { TBelongsTo, StatusType } from './_generics';
import { ActivityView } from './Activities';
import { ContentItemView } from './PageContent';
import { Signature } from './Signature';

export type OrderModel = {
  key: string;
  articleCode: string;
  name: string;
  description: string;
};
export type OrderView = OrderModel & {
  routing: Record<string, RoutingItemView>;
};

export type RoutingItemModel = TBelongsTo & {
  key: string;
  name: string;
  department: string;
  type: string;
  progress: number;
  status: StatusType;
};
export type RoutingItemView = RoutingItemModel & {
  steps: Record<string, RoutingItemStepView>;
};

export type RoutingItemStepModel = TBelongsTo &
  ContentItemView & {
    key: string;
    progress: number;
    depends: string[];
    status: StatusType;
  };
export type RoutingItemStepView = RoutingItemStepModel & {
  activityGroups: Record<string, ActivityGroupView>;
};

export type ActivityGroupModel = TBelongsTo &
  ContentItemView & {
    key: string;
    performed: Signature | null;
    checked: Signature | null;
  };
export type ActivityGroupView = ActivityGroupModel & {
  activities: Record<string, ActivityView>;
};

export type PageReferenceStep = { routingItemKey: string; stepKey: string };
export type PageReferenceActivityGroup = PageReferenceStep & { activityGroupKey: string };
export type PageReferenceActivity = PageReferenceActivityGroup & { activityKey: string };
export type PageReference = PageReferenceStep | PageReferenceActivityGroup | PageReferenceActivity;
export type InspectionSignatureReference = PageReferenceActivityGroup & {
  item: 'performed' | 'checked';
};

export function isPageReferenceActivity(reference: PageReference): reference is PageReferenceActivity {
  return 'activityKey' in reference;
}
export function isPageReferenceActivityGroup(reference: PageReference): reference is PageReferenceActivityGroup {
  return 'activityGroupKey' in reference && !('activityKey' in reference);
}
export function isPageReferenceStep(reference: PageReference): reference is PageReferenceStep {
  return !('activityGroupKey' in reference) && !('activityKey' in reference);
}
